'use strict';

class MdFileUploadAutorizacionController {
    constructor($scope, Message, Util, Loading, Storage, Auth, baseUrl, $log) {
        'ngInject';

        this.Message = Message;
        this.Util = Util;
        this.baseUrl = baseUrl;
        this.Loading = Loading;
        this.Storage = Storage;
        this.Auth = Auth;
        this.$log = $log;
        this.$scope = $scope;
    }

    $onInit() {

        this.idFile = `file-${this.Util.id()}`;
        this.selectedImage = null;

        this.$scope.deleteImg = (param) => {
            var img = param.parentElement.parentElement.parentElement.getElementsByTagName('img')[0];
            var findFile = param.parentElement.getElementsByTagName('input')[0];
            findFile[0] = null;
            findFile.value = '';
            img.src = null;
        }

        this.$scope.readImage = (param) => {
            const imagen = param.files[0];
            var output = param.parentElement.parentElement.parentElement.getElementsByTagName('img')[0];
            output.src = URL.createObjectURL(imagen);
            output.onload = function() {
                URL.revokeObjectURL(output.src) // free memory
            }
        };
        this.$scope.validImage = (param) => {
            var _this = this;
            const file = param.files[0];
            const filereader = new FileReader()

            filereader.onloadend = (evt) => {
                if (evt.target.readyState === FileReader.DONE) {
                    // eslint-disable-next-line no-undef
                    const uint = (new Uint8Array(evt.target.result)).subarray(0, 4);
                    let bytes = []
                    uint.forEach((byte) => {
                        bytes.push(byte.toString(16))
                    })
                    const hex = bytes.join('').toUpperCase()
                    const type =  _this.$scope.getMimetype(hex);
                    if (file.type !== type) {
                        this.Message.error('La imagen no cumple el formato requerido (png, jpg, jpeg)');
                    } else {
                        _this.$scope.readImage(param);
                    }
                }
            }
            // const blob = file.slice(0, 4);
            filereader.readAsArrayBuffer(file);
        };

        this.$scope.getMimetype = (sign) => {
            switch (sign) {
                case '89504E47':
                    return 'image/png'
                case '47494638':
                    return 'image/gif'
                case 'FFD8FFDB':
                case 'FFD8FFE0':
                    return 'image/jpeg'
                default:
                    return 'unknown'
            }
        };
    }

    isType(item, types) {
        let type = item.type.slice(item.type.lastIndexOf('/') + 1);
        let extension = null;
        if (item.name) {
            extension = item.name.split('.');
            extension = extension[extension.length - 1];

            // Hack para firefox que carga un csv con charset text/plain
            if ((type == 'plain' || type == 'download') && extension == 'csv') {
                return true;
            }
        }

        for (let i in this.charset) {
            if (this.Util.toType(this.charset[i]) == 'array') {
                let subtypes = this.charset[i];
                for (let j in subtypes) {
                    if (types.indexOf(i) != -1 && type == subtypes[j]) {
                        return true;
                    }
                }
            } else {
                if (types.indexOf(i) != -1 && type == this.charset[i]) {
                    return true;
                }
            }
        }

        return false;
    }

    isImage(item) {
        let type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
    }

}

export default MdFileUploadAutorizacionController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/fileUploadAutorizacion/fileUpload.controller.js